import React from "react";

//GUI ELEM
import TextPopup from "./TextPopup";
import ImagePopup from "./ImagePopup";
import VideoPopup from "./VideoPopup";

//TS
import { Hotspot } from "../../../../Types";

const ViewerHotspot = (props: {
  popup: Hotspot;
  tourData: any;
  zoom: number;
}) => {
  const { popup, tourData, zoom } = props;

  return (
    <div style={{ color: "white" }}>
      {tourData.popups.find((one: any) => one.id === popup.target)?.type ===
      "text" ? (
        <TextPopup tourData={tourData} popup={popup} zoom={zoom} />
      ) : tourData.popups.find((one: any) => one.id === popup.target)?.type ===
        "video" ? (
        <VideoPopup tourData={tourData} zoom={zoom} popup={popup} />
      ) : tourData.popups.find((one: any) => one.id === popup.target)?.type ===
        "image" ? (
        <ImagePopup zoom={zoom} tourData={tourData} popup={popup} />
      ) : (
        "err "
      )}
    </div>
  );
};

export default ViewerHotspot;
